import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

const EFFY_FORM_FIELD_DEFAULT_OPTIONS = {
    appearance: 'outline',
    hideRequiredMarker: true,
};
const provideEffyMaterialFormField = {
    provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
    useValue: EFFY_FORM_FIELD_DEFAULT_OPTIONS,
};

/**
 * Generated bundle index. Do not edit.
 */

export { EFFY_FORM_FIELD_DEFAULT_OPTIONS, provideEffyMaterialFormField };
